// @ts-nocheck

import React, { memo } from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import GRIcon from '../../modules/gift-race/components/GRIcon';
import {
  MenuDesktopArrowIcon,
  SportsMenuBtnContent,
  SportsMenuBtnLabel,
  SportsMenuListItem,
} from '../../styled-components/shared';
import Counter from '../Counter';

const StyledGRIcon = styled(GRIcon)`
  margin: 0 0.25em;
`;

type MenuDestkopGRButtonProps = {
  nbGRNotifications: number;
  openGRView: () => void;
};

const MenuDestkopGRButton = ({ nbGRNotifications, openGRView }: MenuDestkopGRButtonProps) => {
  return (
    <SportsMenuListItem onClick={openGRView}>
      <SportsMenuBtnContent>
        <StyledGRIcon />
        <SportsMenuBtnLabel $separator={true}>
          {__('The Gift Race')}
          {nbGRNotifications ? <Counter counter={nbGRNotifications} /> : null}
        </SportsMenuBtnLabel>
      </SportsMenuBtnContent>
      <MenuDesktopArrowIcon className="see-all-btn" />
    </SportsMenuListItem>
  );
};

export default memo<MenuDestkopGRButtonProps>(MenuDestkopGRButton);
